import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problemvaping() {
  return (
    <section className="problem_vaping p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="intro_impact">
              <StaticImage
                src="../../../images/case-studies/stop-vaping/problem.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={671}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>Problem</h2>
            <p>
              Our client had a vision to build an addiction-free society by
              leveraging technology to help the youth and young adults
              understand the downsides of vaping.
            </p>
            <p>
              As the previous year recorded more than 2700 cases
              (Vaping-Associated Pulmonary Injury) among young adults aged 18 –
              34, the primary objective was hyper-focused on motivating young
              adults to quit vaping and marijuana addiction.
            </p>
            <p>
              For this reason, a community-based application that could guide
              its audience about the adverse health effects of vaping, while
              enabling them to follow expert tips and practices to stay healthy
              is what the app was intended to be.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problemvaping;
